export default {"src":"/_next/static/media/dream.4e5779ae.svg","height":520,"width":800,"blurWidth":0,"blurHeight":0};